const extensions = {
  document: {
    navigation: "x-scalar-navigation",
    activeAuth: "x-scalar-active-auth",
    activeServer: "x-scalar-active-server"
  },
  workspace: {
    darkMode: "x-scalar-dark-mode",
    defaultClient: "x-scalar-default-client",
    activeDocument: "x-scalar-active-document",
    theme: "x-scalar-theme"
  }
};
export {
  extensions
};
//# sourceMappingURL=extensions.js.map
